module.exports = __webpack_public_path__ + "img/title_news.a384be42.png";